import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  change,
  formValueSelector,
  isDirty,
  isInvalid,
  isPristine,
  getFormValues,
} from 'redux-form';
import {
  getOrderShipments,
  orderIncludesPurelyPreOrderItems,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import {
  getAutocompleteTypesParam,
  getMapboxSwitch,
  getHolidayMessage,
  getIsDynamicFreeShippingEnabled,
  getOrderTrackingEnhancementEnabled,
  getIsInternationalPhoneNumber,
} from '../../../../../../reduxStore/selectors/session.selectors';
import {
  getUserEmail,
  getUserLoggedInState,
  getUserPhoneNumber,
} from '../../../../account/User/container/User.selectors';
import BagPageSelector, {
  getFreeShippingThresholdValue,
  getOrderType,
} from '../../../BagPage/container/BagPage.selectors';
import {
  addNewShippingAddress as addNewShippingAddressAction,
  getZipCodeSuggestedAddress,
  setPhoneCountry,
  updateShippingAddress,
} from '../../../Checkout/container/Checkout.action';
import CheckoutSelector, {
  getABTestForZipCode,
  getZipCodeLoader,
  isGuest,
  isUsSite,
} from '../../../Checkout/container/Checkout.selector';
import GiftCardsSelectors from '../../../Checkout/organisms/GiftCardsSection/container/GiftCards.selectors';
import {
  clearEddTTL,
  getEddData,
  resetEddData,
} from '../../../common/molecules/EddComponent/container/EddComponent.actions';
import {
  getEddAllowedStates,
  getEddFeatureSwitch,
} from '../../../common/molecules/EddComponent/container/EddComponent.selectors';
import SMSNotificationsSelectors from '../../../Confirmation/organisms/SMSNotifications/container/SMSNotifications.selectors';
import ShippingAddressForm from '../../molecules/ShippingForm';
import { clickedOutsideShipping, saveAndContinueShipping } from '../SinglePageCheckout.actions';
import { SPC_SECTION } from '../SinglePageCheckout.constants';
import {
  getAllShippingAddressList,
  getSinglePageCheckoutSectionState,
} from '../SinglePageCheckout.selector';
import { getContactFormValues, getShippingFormValuesFromSS } from './Shipping.utils';
import { getSessionStorage } from '../../../../../../utils';
import { getContactFormValuesFromSS } from '../../molecules/ContactForm/ContactForm.util';
import {
  getProductTotal,
  getShippingTotal,
} from '../../../common/organism/OrderLedger/container/orderLedger.selector';

export const ShippingFormContainer = (props) => {
  return <ShippingAddressForm {...props} />;
};

const mapStateToProps = (state, { formName }) => {
  const shippingFormInput = state.form[formName]?.values || {};
  const pristine = isPristine(formName)(state);
  const dirty = isDirty(formName)(state);
  const invalid = isInvalid(formName)(state);
  const selector = formValueSelector('selectingFormValues');
  const firstName = selector(state, 'firstName');
  const userAddresses = getAllShippingAddressList(state);
  const emailSignUpFlags = BagPageSelector.getIfEmailSignUpDone(state);
  const emailSignUpCaRichText = CheckoutSelector.getEmailSignUpCaRichTextSelector(state);
  const orderHasPickUp = CheckoutSelector.getIsOrderHasPickup(state);
  const isChildrenPalace = SMSNotificationsSelectors.getChildrenPalaceKey(state);
  const isGymboree = SMSNotificationsSelectors.getGymboreeKey(state);
  const isSnJ = SMSNotificationsSelectors.getSNJKey(state);
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.SHIPPING);
  const contactFormValuesFromSS = getShippingFormValuesFromSS(contactData);
  const contactSectionValues = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  const shippingContactInfo = CheckoutSelector.getShippingContactInfo(state);
  const emailAddressFromSS = getContactFormValuesFromSS(contactSectionValues);
  const isLoggedIn = getUserLoggedInState(state);
  const loggedInUser = {
    emailAddress: getUserEmail(state),
    phoneNumber: getUserPhoneNumber(state),
  };
  const emailFailSafe = getSessionStorage('emailForFailSafe') || false;
  const venmoStatus = getSessionStorage('isVenmoPayment') || false;
  const userEmail = venmoStatus
    ? CheckoutSelector?.getVenmoUserEmail(state)
    : CheckoutSelector?.getUserEmailForShipping(state);
  const savedEmail = userEmail || emailAddressFromSS?.emailAddress;

  return {
    mapboxAutocompleteTypesParam: getAutocompleteTypesParam(state),
    mapboxSwitch: getMapboxSwitch(state),
    shippingFormInput,
    firstName,
    pristine,
    dirty,
    invalid,
    isGuestUser: isGuest(state),
    isMobile: CheckoutSelector.getIsMobile(),
    isSaveToAddressBookChecked: CheckoutSelector.getSaveToAddressBook(state),
    shippingAddressId: CheckoutSelector.getShippingAddressID(state),
    shippingAddress: CheckoutSelector.getShippingAddress(state),
    syncErrorsObject: CheckoutSelector.getSyncError(state),
    address: CheckoutSelector.getAddressFields(state),
    userAddresses,
    onFileAddressKey: CheckoutSelector.getOnFileAddressKey(state), // selected address Id in dropdown
    newUserPhoneNo: getUserPhoneNumber(state), // newly added user phone number to be shown as default in mobile number field in address form
    setAsDefaultShipping: CheckoutSelector.getDefaultShipping(state),
    zipCodeABTestEnabled: getABTestForZipCode(state),
    getZipCodeSuggestedAddress,
    zipCodeLoader: getZipCodeLoader(state),
    isEDD: getEddFeatureSwitch(state),
    cartOrderItems: BagPageSelector.getOrderItems(state),
    eddAllowedStatesArr: getEddAllowedStates(state),
    currentOrderId: CheckoutSelector.getCurrentOrderId(state),
    formMetaInfo: {},
    formSyncError: CheckoutSelector.getSyncError(state),
    submitErrors: {},
    checkoutServerError: CheckoutSelector.getCheckoutServerError(state),
    isLoadingShippingMethods: GiftCardsSelectors.getIsLoading(state),
    isUpdatingShipmentMethods: GiftCardsSelectors.getIsUpdatingShipmentMethods(state),
    smsSignUpLabels: CheckoutSelector.getSmsSignUpLabels(state),
    isUsSite: isUsSite(state),
    emailSignUpFlags,
    emailSignUpCaRichText,
    orderHasPickUp,
    isChildrenPalace,
    isGymboree,
    isSnJ,
    contactFormValues: state.form.ShippingForm?.values || {},
    contactFormValuesFromSS,
    shippingContactInfo,
    loggedInUser,
    contactData,
    isLoggedIn,
    contactFormData: getContactFormValues({
      isLoggedIn,
      loggedInUser,
      contactFormValuesFromSS,
      shippingContactInfo,
    }),
    preOrderItemsIncluded: orderIncludesPurelyPreOrderItems(state),
    emailFailSafe,
    venmoStatus,
    emailAddressFromSS,
    savedEmail,
    shippingFormValues: getFormValues('ShippingForm')(state),
    shippingState: BagPageSelector.getShippingAddressState(state),
    holidayMessageEnabled: getHolidayMessage(state),
    freeShippingThershold: getFreeShippingThresholdValue(state),
    shippingTotal: getShippingTotal(state),
    isDynamicFreeShippingEnabled: getIsDynamicFreeShippingEnabled(state),
    shipments: getOrderShipments(state),
    orderType: getOrderType(state),
    productTotal: getProductTotal(state),
    isInternationalPhoneNumberEnabled: getIsInternationalPhoneNumber(state),
    orderTrackingEnhancementEnabled: getOrderTrackingEnhancementEnabled(state),
  };
};

const mapDispatchToProps = (dispatch, { formName }) => {
  return {
    dispatch,
    dispatchFormFieldChange: (key, value) => dispatch(change(formName, key, value)),
    handleSaveAndContinueShipping: (payload) => dispatch(saveAndContinueShipping(payload)),
    updateShippingAddressData: (payload, afterUpdateAddress) => {
      dispatch(updateShippingAddress(payload, afterUpdateAddress));
    },
    addNewShippingAddress: (payload) => {
      dispatch(addNewShippingAddressAction(payload));
    },
    getZipCodeSuggestedAddress: (payload) => {
      dispatch(getZipCodeSuggestedAddress(payload));
    },
    updateEdd: (payload) => {
      dispatch(getEddData(payload));
    },
    resetShippingEddData: () => {
      dispatch(resetEddData());
    },
    clearEddTTLActn: () => {
      dispatch(clearEddTTL());
    },
    clickedOutsideShipping: (payload) => dispatch(clickedOutsideShipping(payload)),
    setPhoneCountryAction: (payload) => dispatch(setPhoneCountry(payload)),
  };
};

ShippingFormContainer.propTypes = {
  labels: PropTypes.shape({}).isRequired,
  addressFormLabels: PropTypes.shape({}).isRequired,
  mapboxSwitch: PropTypes.bool,
  mapboxAutocompleteTypesParam: PropTypes.string,
  shippingFormInput: PropTypes.shape({}).isRequired,
  dispatchFormFieldChange: PropTypes.func.isRequired,
  shipmentMethods: PropTypes.shape({}),
  selectedShipmentId: PropTypes.string,
  loadShipmentMethods: PropTypes.func.isRequired,
  showCountrySelection: PropTypes.bool,
  updateShipmentMethods: PropTypes.func.isRequired,
};

ShippingFormContainer.defaultProps = {
  mapboxSwitch: false,
  mapboxAutocompleteTypesParam: '',
  shipmentMethods: {},
  selectedShipmentId: '',
  showCountrySelection: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingFormContainer);
